export const Currency = {
    "sr":"SAR",
}